export const EXASPERATED = 'exasperated'
export const CONCERNED = 'concerned'
export const CHEERING = 'cheering'
